import styled from '@emotion/styled';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Content = styled.span`
    font-size: 1.5rem;
    margin-left: 3rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.secondary.main};
`;

const Subtitle = styled.div`
    font-weight: 700;
    font-size: 1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Title = styled.div`
    font-size: 1.7rem;
    font-weight: 200;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

const MarketingBanner = () => {
    return (
        <Container>
            <Content>
                <Title>Scheduled maintenance on Sunday, March 31st from 3am to 12pm EST/7am-4pm GMT</Title>
                <Subtitle>During this period, the service may be temporarily unavailable. We apologize for any inconvenience.</Subtitle>
            </Content>
        </Container>
    );
};

export default MarketingBanner;
